// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Loan batch pre-termination'"></sub-header>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#tab-upload" data-toggle="tab">
          Upload
        </a>
      </li>
      <li>
        <a data-target="#tab-history" data-toggle="tab">
          History
        </a>
      </li>
    </ul>
  </div>

  <div class="tab-content no-print">
    <div class="tab-pane active" id="tab-upload">
      <batch-loan-preterminations-upload></batch-loan-preterminations-upload>
    </div>

    <div class="tab-pane" id="tab-history">
      <batch-loan-preterminations-history></batch-loan-preterminations-history>
    </div>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/loan-pretermination/batch-loan-preterminations.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;